// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.supplier-page-container {
  position: relative;
  min-height: 100vh;
}

.create-order-fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border: none;
}
.create-order-fab:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}
.create-order-fab:active {
  transform: scale(0.95);
}
.create-order-fab .icon {
  color: white;
}

@media (prefers-color-scheme: dark) {
  .create-order-fab {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
  }
  .create-order-fab:hover {
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.5);
  }
}
@media (max-width: 768px) {
  .create-order-fab {
    bottom: 16px;
    right: 16px;
    width: 48px;
    height: 48px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Supplier/Supplier.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AACF;AACE;EACE,qBAAA;EACA,yCAAA;AACJ;AAEE;EACE,sBAAA;AAAJ;AAGE;EACE,YAAA;AADJ;;AAKA;EACE;IACE,yCAAA;EAFF;EAGE;IACE,yCAAA;EADJ;AACF;AAKA;EACE;IACE,YAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EAHF;AACF","sourcesContent":[".supplier-page-container {\n  position: relative;\n  min-height: 100vh;\n}\n\n.create-order-fab {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  border: none;\n\n  &:hover {\n    transform: scale(1.1);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .icon {\n    color: white;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .create-order-fab {\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);\n    &:hover {\n      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.5);\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .create-order-fab {\n    bottom: 16px;\n    right: 16px;\n    width: 48px;\n    height: 48px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
